<medpace-card>
    <medpace-card-header>
        <div #overrideHeader>
            <ng-content select="medpace-card-header"></ng-content>
        </div>
        @if (!overrideHeader.hasChildNodes()) {
            <div class="c-card__ribbon">
                <div class="c-card__item c-card__item--left mb-2">
                    <h3>{{ title }}</h3>
                    @if (showTitleAsteriskWhenEditMode && mode === 'edit') {
                        <span class="required-asterisk">*</span>
                    }
                </div>
                @if (showSwitchModeButton) {
                    <div>
                        @if (mode === 'edit') {
                            <mds-button
                                (clickEvent)="handleSaveClick()"
                                label="Save"
                                [variant]="'tonal'"
                                color="primary"
                                [id]="'saveBtn'"
                            ></mds-button>
                        }
                        @if (mode === 'view') {
                            <mds-button
                                (clickEvent)="handleEditClick()"
                                label="Edit"
                                [variant]="'tonal'"
                                color="primary"
                                [id]="'editBtn'"
                            ></mds-button>
                        }
                    </div>
                }
            </div>
        }
    </medpace-card-header>

    <medpace-card-content>
        <form #ngForm="ngForm" [formGroup]="formGroup" appScrollToInvalidControlOnSubmit>
            <div #overrideContent>
                <ng-content select="medpace-card-content"></ng-content>
            </div>
            @if (!overrideContent.hasChildNodes()) {
                <div>
                    @if (isLoading === true) {
                        <medpace-loading-card></medpace-loading-card>
                    }
                    @if (isLoading === false) {
                        <div>
                            @if (mode === 'edit') {
                                <ng-content select="medpace-editable-card-edit-mode-content"></ng-content>
                            }
                            @if (mode === 'view') {
                                <ng-content select="medpace-editable-card-view-mode-content"></ng-content>
                            }
                        </div>
                    }
                </div>
            }
        </form>
    </medpace-card-content>
</medpace-card>
